<template>
  <Modal :value="open" :onClose="close" :close="false" :title="title">
    <b-row>
      <b-col>
        <Select
          label="Tipo Desconto"
          id="discountType"
          v-model="discountType"
          labelBold
          :options="types"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <Money
          v-if="discountType === 1"
          ref="discount"
          id="discount"
          label="Desconto"
          inputClass="form-control input"
          labelBold
          :options="optionMoney"
          :onEnter="save"
          v-model="valueDiscount"
        />
        <Money
          v-else
          ref="discount"
          id="discount"
          label="Desconto"
          inputClass="form-control input"
          labelBold
          :options="optionMoney"
          :onEnter="save"
          v-model="percentDiscount"
        />
      </b-col>
    </b-row>
    <div class="confirm-buttons">
      <Button type="error" @click="close()">Fechar</Button>
      <Button type="success" @click="save()">Gravar</Button>
    </div>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { mapState, mapActions } from 'vuex';
import { Button, Select } from '@/components/Form';
import FormatMixin from '@/modules/Application/mixins/FormatMixin';
import Money from '../Form/InputMoney';

export default {
  name: 'ModalDescontoAcrescimoItem',
  mixins: [FormatMixin],
  components: {
    Modal,
    Button,
    Select,
    Money,
  },
  computed: {
    ...mapState('pdv', ['discount', 'discountItem', 'total', 'extraValue']),
  },
  data() {
    return {
      types: [
        {
          value: 1,
          text: 'Valor R$',
        },
        {
          value: 2,
          text: 'Percentual %',
        },
      ],
      discountType: 1,
      extraValueType: 1,
      valueDiscount: 0,
      percentDiscount: 0,
      valueExtraValue: 0,
      percentExtraValue: 0,
      optionMoney: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        precision: 2,
        masked: true,
      },
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
    title: {
      default: 'Desconto do Item',
    },
  },
  methods: {
    ...mapActions('pdv', [
      'setDiscountItem',
      'setExtraValueItem',
      'handleModalDiscountExtraValueItem',
    ]),
    setInitialState() {
      this.valueDiscount = 0;
      this.percentDiscount = 0;
      this.valueExtraValue = 0;
      this.percentExtraValue = 0;
    },
    save() {
      this.setDiscountItem({
        valueDiscount: this.valorUS(this.valueDiscount),
        percentDiscount: this.valorUS(this.percentDiscount),
      });

      this.setExtraValueItem({
        percentExtraValue: this.valorUS(this.percentExtraValue),
        valueExtraValue: this.valorUS(this.valueExtraValue),
      });

      this.handleModalDiscountExtraValueItem();
      this.setInitialState();
    },
  },
};
</script>

<style>
.text-center label {
  margin-bottom: 10px !important;
}
</style>
